import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";
import { TIngredientPayload } from "../../sdk/utils/api/ingredients";

export const useResolveUnmatchedIngredient = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<types.IIngredient, unknown, { unmatchedId: string; body: { ingredientId: string } | { ingredient: TIngredientPayload & { name: string } } }> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<types.IIngredient, unknown, { unmatchedId: string; body: { ingredientId: string } | { ingredient: TIngredientPayload & { name: string } } }>({
        mutationFn: async (parameters: { unmatchedId: string; body: { ingredientId: string } | { ingredient: TIngredientPayload & { name: string } } }) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.resolveUnmatched(parameters.unmatchedId, parameters.body, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
